import { render, staticRenderFns } from "./SurfInlineTwoTextStyle1.vue?vue&type=template&id=40d4a26a&scoped=true"
import script from "./SurfInlineTwoTextStyle1.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfInlineTwoTextStyle1.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SurfInlineTwoTextStyle1.vue?vue&type=style&index=0&id=40d4a26a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d4a26a",
  null
  
)

export default component.exports